{
  "header": {
    "title": "Frågehistorik",
    "description": "Granska och analysera tidigare feedbacksvar"
  },
  "emptyState": {
    "company": {
      "title": "Ingen data insamlad än",
      "description": "Din resa börjar här! När anställda börjar dela feedback under första månaden kommer du att se insikter och trender dyka upp"
    },
    "directReports": {
      "title": "Inga direktrapporter",
      "description": "Du har inga direktrapporter tilldelade, men du kan ändå delta i enkäter och dela värdefull feedback!",
      "bottomAction": {
        "label": "Om du tror att detta är ett misstag, kontakta din chef",
        "helpText": "Hjälptext"
      }
    }
  },
  "NotEnoughResponse": {
    "title": "Inte tillräckligt med svar än",
    "description": "Resultatet visas när minst 3 svar har samlats in"
  },
  "tabs": {
    "company": "Hela företaget",
    "allReports": "Alla rapporter",
    "directReports": "Direktrapporter",
    "myTeam": "Mitt team"
  },
  "leaderDropdown": {
    "triggerLabel": "Ledare",
    "searchPlaceholder": "Hitta en ledare"
  },
  "categoryDropdown": {
    "triggerLabel": "Kategorier"
  },
  "detailsPage": {
    "header": {
      "description": "Granska och analysera tidigare feedbacksvar",
      "exportButton": "Exportera",
      "backButton": "Tillbaka till frågehistorik"
    },
    "tabs": {
      "company": "Hela företaget",
      "allReports": "Alla rapporter",
      "directReports": "Direktrapporter",
      "myTeam": "Mitt team"
    },
    "leaderDropdown": {
      "triggerLabel": "Ledare",
      "searchPlaceholder": "Hitta en ledare"
    },
    "satisfactionScoreSection": {
      "title": "Tillfredsställelsepoäng",
      "barChart": {
        "title": "Svarsfördelning",
        "agreeTitle": "Instämmer",
        "somewhatAgreeTitle": "Instämmer delvis",
        "neutralTitle": "Neutral",
        "somewhatDisagreeTitle": "Instämmer delvis inte",
        "disagreeTitle": "Instämmer inte"
      }
    },
    "directReportSection": {
      "title": "Direktrapportens team",
      "empty": {
        "title": "Inga direktrapporterande ledare",
        "description": "Den här ledaren har inga underordnade ledare, eller så har uppgifter inte laddats ännu."
      }
    },
    "participationRateSection": {
      "title": "Deltagandefrekvens"
    },
    "responsesCount_one": "{{count}} svar",
    "responsesCount_other": "{{count}} svar",
    "previousResponseSection": {
      "title": "Tidigare svar"
    },
    "enps": {
      "categoryName": "eNPS",
      "questionText": "Hur sannolikt är det att du rekommenderar att arbeta för vårt företag?",
      "scoreSection": {
        "title": "eNPS-poäng",
        "companyAverage": "Företagets genomsnitt: {{score}}",
        "tooltip": {
          "description": "Employee Net Promoter Score (eNPS) beräknas genom att medarbetare svarar på en skala från 0 till 10:",
          "promoters": "Ambassadörer (9-10)",
          "passives": "Passiva (7-8)",
          "detractors": "Kritiker (0-6)",
          "formulaLabel": "Formeln är:",
          "formula": "% Ambassadörer - % Kritiker = eNPS",
          "resultRange": "Resultatet går från -100 till 100, där en högre poäng är bättre. Passiva exkluderas från den slutliga beräkningen."
        }
      },
      "distribution": {
        "title": "Svarsfördelning",
        "subtitle": "Antal svar",
        "detractors": "Kritiker ({{percentage}}%)",
        "passives": "Passiva ({{percentage}}%)",
        "promoters": "Ambassadörer ({{percentage}}%)",
        "xAxisLabel": "Svarspoäng"
      },
      "trendSection": {
        "title": "eNPS över tid",
        "subtitle": "6 månaders uppdelning",
        "yourTeam": "Ditt team",
        "companyAverage": "Företagets genomsnitt"
      },
      "directReportSection": {
        "title": "Direktrapportens team",
        "teamTitle": "{{leaderName}}s team"
      },
      "previousResponseSection": {
        "title": "Tidigare svar",
        "columns": {
          "date": "Datum",
          "score": "eNPS-poäng",
          "responsePercentage": "Svarsfrekvens"
        }
      }
    }
  }
}
